import React, {FC} from 'react';

import {Trans} from '../../../../../libs/shared/core/src/helpers/internationalization/react';
import {Banner, BannerTypesEnum} from '../../../../../libs/shared/ui/src/components/banners/banner';
import {BannerCloseAction} from '../../../../../libs/shared/ui/src/components/banners/bannerCloseAction';
import {BannerContent} from '../../../../../libs/shared/ui/src/components/banners/bannerContent';
import {BannerContentTitle} from '../../../../../libs/shared/ui/src/components/banners/bannerContentTitle';
import {BannerIcon} from '../../../../../libs/shared/ui/src/components/banners/bannerIcon';
import {BannerPrioritiesEnum} from '../../../../../libs/shared/ui/src/components/banners/bannersContext';
import {useUserTheme} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {
  AccountsErrorBannerState,
  AccountsErrorBannerTypesEnum,
} from '../../../../store/panels/app/banners/bannersState';

/*
 * Props.
 */

interface AccountsErrorBannerProps {
  state: AccountsErrorBannerState;
  onDismissClick: () => void;
}

/*
 * Component.
 */

export const AccountsErrorBanner: FC<AccountsErrorBannerProps> = (props) => {
  const theme = useUserTheme();
  const {state, onDismissClick} = props;

  return (
    <Banner
      bannerType={BannerTypesEnum.MULTILINE}
      color={theme.palette.red.shade40}
      priority={BannerPrioritiesEnum.ERROR}
    >
      <BannerCloseAction onClick={onDismissClick} />
      <BannerIcon iconName="briefcaseFilledSmall" />
      <BannerContent>
        <BannerContentTitle>{getBannerContentTitle(state)}</BannerContentTitle>
        <Trans id="accounts-error-banner-please-try-again-message">Please try again.</Trans>
      </BannerContent>
    </Banner>
  );
};

const getBannerContentTitle = (state: AccountsErrorBannerState) => {
  switch (state.accountsErrorType) {
    case AccountsErrorBannerTypesEnum.CREATION_FAILED:
      return <Trans id="accounts-error-banner-account-creation-failed">Account creation failed.</Trans>;
    case AccountsErrorBannerTypesEnum.DELETION_FAILED:
      return <Trans id="accounts-error-banner-account-deletion-failed">Account deletion failed.</Trans>;
    case AccountsErrorBannerTypesEnum.DOMAIN_UPDATE_FAILED:
      return <Trans id="accounts-error-banner-domain-update-failed">Domain update failed.</Trans>;
    case AccountsErrorBannerTypesEnum.DOMAIN_REMOVAL_FAILED:
      return <Trans id="accounts-error-banner-domain-removal-failed">Domain removal failed.</Trans>;
    default:
      return (
        <Trans id="accounts-error-banner-unexpected-error-occurred">An unexpected error occurred.</Trans>
      );
  }
};
